import { NumberField } from '../components/Table/fields/NumberField';
import { TextField } from '../components/Table/fields/TextField';
import { NamedEntity } from '../types/entities/NamedEntity';
import { SchemaWithClient } from '../types/SchemaWithClient';
import { Client } from '../services/Client';
import { SPTextField } from '../components/Table/fields/SPTextField';
import { SPNumberField } from '../components/Table/fields/SPNumberField';

const makeEnumItem = (
  name: string,
  url: string,
  pluralName?: string
): SchemaWithClient<NamedEntity> => {
  return {
    name,
    pluralName: (pluralName === '' ? `${name}s` : pluralName) || `${name}s`,
    tabs: [
      {
        id: 1,
        label: 'General',
        name: 'general',
      },
    ],
    columns: {
      name: {
        name: 'Name',
        required: true,
        fieldRenderer: TextField,
        slidePaneFieldRenderer: SPTextField,
        fieldType: 'text',
      },
      id: {
        name: 'ID',
        required: true,
        fieldRenderer: NumberField,
        slidePaneFieldRenderer: SPNumberField,
        fieldType: 'number',
        readOnly: true,
      },
    },
    client: new Client('/enums' + url),
  };
};

export const enumItems = {
  driver: makeEnumItem('Driver', '/drivers'),
  icon: makeEnumItem('Icon', '/icons'),
  bookingAgent: makeEnumItem('Booking Agent', '/booking-agents'),
  address: makeEnumItem('Address', '/addresses', 'Addresses'),
  vehicle: makeEnumItem('Vehicle', '/vehicles'),
  stripper: makeEnumItem('Stripper', '/strippers'),
  accommodationRoomTypes: makeEnumItem('Room', '/accommodation-room-types'),
  groupType: makeEnumItem('Group Type', '/group-types'),
  country: makeEnumItem('Country', '/countries', 'Countries'),
  language: makeEnumItem('Language', '/languages'),
  salesPartner: makeEnumItem('Sales Partner', '/sales-partners'),
  bar: makeEnumItem('Bar', '/bars'),
  club: makeEnumItem('Club', '/clubs'),
  restaurant: makeEnumItem('Restaurant', '/restaurants'),
  stripBar: makeEnumItem('Strip Bar', '/strip-bars'),
  flight: makeEnumItem('Flight', '/flights'),
  guide: makeEnumItem('Guide', '/guides'),
  busProvider: makeEnumItem('Bus Provider', '/bus-providers'),
  serviceProvider: makeEnumItem('Service Provider', '/service-providers'),
  bookingType: makeEnumItem('Booking Type', '/booking-types'),
  file: makeEnumItem('File', '/files'),
  accommodation: makeEnumItem('Accommodation', '/accommodations'),
  accommodationProvider: makeEnumItem(
    'Accommodation Providers',
    '/accommodation-providers'
  ),
  accommodationType: makeEnumItem(
    'Accommodation Types',
    '/accommodation-types'
  ),
  roomType: makeEnumItem('Room Type', '/room-types'),
  currency: makeEnumItem('Currency', '/currencies'),
  paymentMethod: makeEnumItem('Payment Method', '/payment-methods'),
  user: makeEnumItem('User', '/users'),
  partnerDaytime: makeEnumItem('Partner Daytime', '/partner-daytime'),
  stripperRole: makeEnumItem('Stripper Roles', '/stripper-roles'),
  activityCategory: makeEnumItem('Activity Category', '/activity-categories'),
  activityReservationLocations: makeEnumItem(
    'Activity Reservation Location',
    '/activity-reservation-locations'
  ),
  paidBy: makeEnumItem('Paid By', '/paid-bies'),
  /* bookedBy: makeEnumItem('Booked By', '/booked-bies'),*/
  paymentDue: makeEnumItem('Payment Due', '/payment-dues'),
  legalEntity: makeEnumItem('Legal Entity', '/legal-entities'),
  serviceProviderType: makeEnumItem(
    'Service Provider Type',
    '/service-provider-types'
  ),
  addressType: makeEnumItem('Address Type', '/address-types'),
  languageLevel: makeEnumItem('Language Level', '/language-levels'),
  paymentRegularity: makeEnumItem(
    'Payment Regularity',
    '/payment-regularities'
  ),
  activityReservation: makeEnumItem(
    'Activity Reservation',
    '/activity-reservations'
  ),
  singleStripperReservation: makeEnumItem(
    'Stripper Reservation',
    '/single-stripper-reservations'
  ),
  serviceType: makeEnumItem('Service Type', '/service-types'),
  activityType: makeEnumItem('Activity Type', '/activity-types'),
  userType: makeEnumItem('User Type', '/user-types'),
  activity: makeEnumItem('Activity', '/activity'),
  pickupPlace: makeEnumItem('Pickup Place', '/pickup-places'),
  invoiceMode: makeEnumItem('Invoice Mode', '/invoice-mode'),
  corporate: makeEnumItem('Corporate', '/corporates'),
  corporatePayments: makeEnumItem('Corporate Payment', '/corporate-payments'),
  guideHour: makeEnumItem('Guide Hour', '/guide-hours'),
  accommodationCategory: makeEnumItem(
    'Accommodation Category',
    '/accommodation-category'
  ),
  accommodationCostType: makeEnumItem(
    'Accommodation Cost Type',
    '/accommodation-cost-type'
  ),
  subRole: makeEnumItem('Sub Role', '/sub-roles'),
  accommodationRequests: makeEnumItem('Accommodation Requests', '/accommodation-requests'),
  group: makeEnumItem('Group', '/groups'),
  serviceReservationType: makeEnumItem(
    'Service Reservation Type',
    '/service-reservation-types'
  ),
};
